module.exports = __webpack_public_path__ + "static/media/placeholder.a1157a9b.jpg";